import { IconButton, Stack, Tooltip } from "@mui/material";
// import { IconAlertTriangle } from "@tabler/icons-react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import React from "react";
import { useTranslation } from "react-i18next";

export enum ERROR_CODES {
  AVAILABILITY_PARAMETERS_NOT_MET = 0
}

interface ErrorListTooltipProps {
  errorCodes: ERROR_CODES[];
  type?: "error" | "warning";
}

const ErrorListTooltip: React.FC<ErrorListTooltipProps> = ({
  errorCodes,
  type = "error"
}) => {
  const { t } = useTranslation();

  const renderErrorCodeToText = (code: ERROR_CODES) => {
    switch (code) {
      case ERROR_CODES.AVAILABILITY_PARAMETERS_NOT_MET:
        return t(
          "ROOSTER.AUTOBOOK.ERROR-TEXT-AVAILABILITY-PARAMETERS-NOT-MET",
          {
            defaultValue:
              "Your provided availability doesn’t meet the required parameters. Please add or adjust your time slots before submitting."
          }
        );

      default:
        return code;
    }
  };

  // Get unique error messages
  const uniqueErrorMessages = React.useMemo(() => {
    const errorMessages = errorCodes.map(renderErrorCodeToText).filter(Boolean);
    return Array.from(new Set(errorMessages));
  }, [errorCodes]);

  return (
    <Tooltip
      title={
        <Stack direction="column">
          {uniqueErrorMessages.map((message, index) => (
            <Stack key={index}>{message}</Stack>
          ))}
        </Stack>
      }
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: "480px"
          }
        }
      }}
    >
      <IconButton
        aria-label={t("ROOSTER.COMMON.VIEW-ERRORS", {
          defaultValue: "View errors"
        })}
        color="error"
      >
        <WarningAmberRoundedIcon
          sx={{ color: type === "error" ? "#dc4233" : "#ff9800" }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default ErrorListTooltip;
